import { SxProps } from '@mui/system';

export const computeDialogSize = (size: 'small' | 'medium' | 'large' | 'full'): SxProps => {
  switch (size) {
    case 'small':
      return { width: '444px', maxHeight: '80%', margin: 0 };
    case 'medium':
      return { width: '600px', maxHeight: '80%', margin: 0 };
    case 'large':
      return { width: '900px', maxHeight: '80%', margin: 0 };
    case 'full':
      return { width: '100%', maxHeight: '100%', margin: 0 };
    default:
      return {};
  }
};
